<template>
  <v-row
    justify="center"
    class="c-confirm-modal"
  >
    <v-dialog
      v-model="dialog"
      @click:outside="handleClose()"
      scrollable
      max-width="400"
    >
      <v-card class="px-5 py-5">
        <div class="c-confirm-modal__content text-center pt-5">
          <img class="mb-2" :src="icon" alt="">
          <p class="c-confirm-modal__title">{{ title }}</p>
          <p class="c-confirm-modal__text">{{ message }}</p>
        </div>

        <v-card-actions class="pb-5">
          <v-btn
            class="px-3"
            color="#444444"
            dark
            large
            min-width="128"
            @click="handleOk()"
          >
            Так
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="#444444"
            outlined
            large
            min-width="128"
            @click="handleClose()"
          >
            Скасувати
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'c-confirm-modal',
  props: {
    uuid: {
      type: String,
      default: null
    },
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    message: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: require('@/assets/icon/warning.svg')
    },
    title: {
      type: String,
      default: 'Впевнені?'
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
    handleOk(uuid = this.uuid, item = this.item) {
      this.$emit('handleOk', { uuid, item })
      this.closeModal()
    },
    handleClose(uuid = this.uuid, item = this.item) {
      this.$emit('handleClose', { uuid, item })
      this.closeModal()
    }
  }
}
</script>

<style lang="scss">
  .c-confirm-modal {
    &__content {
      color: #2E2C3D;
    }
    &__title {
      font-size: 1.5rem;
      font-weight: 700;
    }
    &__text {
      font-size: 18px;
    }
  }
</style>